"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPlansEndpoints = createPlansEndpoints;
/**
 * Etkinliğin paket yetkilendirmesi (Faz 4 · Story 21.1).
 *
 * TEK okuma ucu; YAZMA UCU YOKTUR (P7: `plan` istemciden gelen hiçbir gövdeyle
 * değişmez). Panelin tavan şeridi, paket ekranı ve kilit yüzeyleri bu tek
 * çağrıdan beslenir — hiçbir ekran kendi sayımını yapmaz (P6).
 */
function createPlansEndpoints(client) {
    return {
        plans: {
            event: (eventId) => client.call('/events/{eventId}/plan', 'get', { path: { eventId } }),
        },
    };
}
//# sourceMappingURL=plans.js.map